<template>
  <v-row class="ma-0" id="searchBar">
    <v-text-field
      clearable
      label=""
      type="text"
      dense
      hide-details
      solo
      class="elevation-0"
      v-model="keyWords"
      @click:clear="clear"
    >
      <template v-slot:append>
        <v-btn outlined tile class="primary white--text" @click="search">
          搜索
        </v-btn>
      </template>
    </v-text-field>
  </v-row>
</template>

<script>
export default {
  name: "SearchBar",
  data: () => ({
    keyWords: "",
  }),
  methods: {
    search() {
      this.$emit("onSearch", this.keyWords);
    },
    clear() {
      this.$emit("onSearch", "");
    },
  },
  destroyed() {
    this.keyWords = "";
  },
};
</script>

<style lang="sass">
#searchBar
  .v-input__slot
    box-shadow: none
    border: 1px solid rgba(0,0,0,0.38)
    padding-right: 0px
  .v-btn
    border: none
    border-left: 1px solid rgba(0,0,0,0.38)!important
</style>
